export default __webpack_public_path__ + "static/1-IMG_2544-69254d76e18b6fe169281498c62a80c1.jpg";